
import { defineComponent } from "vue";
import { configureGame } from "./phaser";
import GameIntro from "@/components/GameIntro.vue";
import InstructionsPopup1 from "@/components/InstructionsPopup1.vue";
import InstructionsPopup2 from "@/components/InstructionsPopup2.vue";
import InstructionsPopup3 from "@/components/InstructionsPopup3.vue";
import InstructionsPopup4 from "@/components/InstructionsPopup4.vue";
import InstructionsPopup5 from "@/components/InstructionsPopup5.vue";
import LevelUpPopup from "@/components/LevelUpPopup.vue";
import LeaderboardPopup from "@/components/LeaderboardPopup.vue";
import RegisterPopup from "@/components/RegisterPopup.vue";
import OrientationPopup from "@/components/OrientationPopup.vue";

export default defineComponent({
  name: "App",
  components: {
    OrientationPopup,
    GameIntro,
    InstructionsPopup1,
    InstructionsPopup2,
    InstructionsPopup3,
    InstructionsPopup4,
    InstructionsPopup5,
    LeaderboardPopup,
    RegisterPopup,
    LevelUpPopup,
  },
  methods: {
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },

    isSafari(){
      return /iPhone/i.test(navigator.userAgent);
    },



    checkOrientation() {
      const goFS = document.getElementById('scrollPop');
      (goFS as HTMLDivElement).addEventListener("click", function() {
          document.body.requestFullscreen();
          const scroller = document.querySelector('.scroll');
            (scroller as HTMLDivElement).style.display = 'none'
      }, false);
      if(this.isSafari()){
        const scroller = document.querySelector('.scroll');
        (scroller as HTMLDivElement).style.display = 'none'
      }
      if (this.isMobile()) {
        if (window.innerWidth < window.innerHeight && !window.isRegisterOpen()) {
          window.showOrHideOrientationPopup(true);
        } else {
          window.showOrHideOrientationPopup(false);
        }
      } else {
        if (window.innerWidth < window.innerHeight && !window.isRegisterOpen()) {
          window.showOrHideOrientationPopup(true);
        } else {
          window.showOrHideOrientationPopup(false);
        }
      }
    },
  },
  mounted() {
    configureGame(this.$refs.gameContainer as HTMLDivElement);
    this.checkOrientation();
    window.addEventListener("orientationchange", this.checkOrientation);
    window.addEventListener("resize", this.checkOrientation);
    const phaserGame = document.querySelector('.phaser-game');
    (phaserGame as HTMLDivElement).style.display = 'none'
    if (this.isMobile()) {
      window.showOrHideIntro(false);
      window.showOrHideInstructionPopup1(true);
    } else {
      window.showOrHideIntro(true);
    }
  },
});
